export const taskManualVerification = 'manual_verification'
export const tapNationVerification = 'tap_nation'